import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-operating_record",
  "use": "icon-operating_record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-operating_record\"><path d=\"M512 898.844444A386.844444 386.844444 0 1 1 512 125.155556a386.844444 386.844444 0 0 1 0 773.688888z m0-56.888888A329.955556 329.955556 0 1 0 512 182.044444a329.955556 329.955556 0 0 0 0 659.911112z\" p-id=\"2138\" fill=\"#ffffff\" /><path d=\"M497.777778 360.903111a28.444444 28.444444 0 0 1 28.444444 28.444445v113.891555l80.725334 69.518222a27.306667 27.306667 0 0 1 2.104888 39.367111l-0.739555 0.796445a28.444444 28.444444 0 0 1-39.367111 2.161778l-82.773334-71.111111a28.444444 28.444444 0 0 1-16.839111-25.998223v-128.568889a28.444444 28.444444 0 0 1 28.444445-28.444444z\" p-id=\"2139\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/operating_record.svg
// module id = Q7Py
// module chunks = 39